import { render, staticRenderFns } from "./ppDashBoard.vue?vue&type=template&id=b64834ee&"
import script from "./ppDashBoard.vue?vue&type=script&lang=js&"
export * from "./ppDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./ppDashBoard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports